import PropType from 'prop-types'
import React from 'react'
import { useRecoilState } from 'recoil'

import { selectedResultsStateById } from '../recoil/state/result'

import { Checkbox, TEXT_VARIANT_BOLD, Text } from 'mailup-web-components'

const ResultCheckbox = ({ id, label }) => {
  const [checked, setChecked] = useRecoilState(selectedResultsStateById(id))

  return (
    <Checkbox
      checked={checked}
      value={id}
      onChange={(e) => setChecked(e.target.checked)}
      data-mu-test="result__check"
      label={
        <Text variant={TEXT_VARIANT_BOLD} htmlElement="span">
          {label}
        </Text>
      }
    />
  )
}

ResultCheckbox.propTypes = {
  id: PropType.number,
  label: PropType.string,
}

export default ResultCheckbox
